import React from 'react';

export default function ComingSoonList({ heading, items = [] }) {
  const lang = localStorage.getItem('language') || 'arm';
  const headingStr = heading ? (heading[lang] || heading.en || '') : '';

  return (
    <section className='main-container main-container-decoration'>
      <div className='description-banner'>
        {headingStr && <h2 className='title-generic'>{headingStr}</h2>}
        <ul className='coming-soon-list list-unstyled'>
          {items.map((item, i) => {
            const title = item.title ? (item.title[lang] || item.title.en || '') : '';
            const date  = item.date  ? (item.date[lang]  || item.date.en  || '') : '';
            const venue = item.venue ? (item.venue[lang] || item.venue.en || '') : '';
            return (
              <li key={i} className='coming-soon-item mb-3'>
                <strong>{title}</strong>
                {date  && <span className='ms-2 text-muted'> — {date}</span>}
                {venue && <span className='ms-2 text-muted'> @ {venue}</span>}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
